module.exports = __webpack_public_path__ + "images/external_images/img/review_sites/amp.png";